import { render, staticRenderFns } from "./buttom.vue?vue&type=template&id=6a9cdc8a&scoped=true&"
import script from "./buttom.vue?vue&type=script&lang=js&"
export * from "./buttom.vue?vue&type=script&lang=js&"
import style0 from "./buttom.vue?vue&type=style&index=0&id=6a9cdc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9cdc8a",
  null
  
)

export default component.exports